/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerRightUpIcon16Light } from './ArrowDCornerRightUpIcon16Light';
import { ArrowDCornerRightUpIcon16Regular } from './ArrowDCornerRightUpIcon16Regular';
import { ArrowDCornerRightUpIcon16Solid } from './ArrowDCornerRightUpIcon16Solid';
import { ArrowDCornerRightUpIcon20Light } from './ArrowDCornerRightUpIcon20Light';
import { ArrowDCornerRightUpIcon20Regular } from './ArrowDCornerRightUpIcon20Regular';
import { ArrowDCornerRightUpIcon20Solid } from './ArrowDCornerRightUpIcon20Solid';
import { ArrowDCornerRightUpIcon24Regular } from './ArrowDCornerRightUpIcon24Regular';
import { ArrowDCornerRightUpIcon24Solid } from './ArrowDCornerRightUpIcon24Solid';
import { ArrowDCornerRightUpIcon32Regular } from './ArrowDCornerRightUpIcon32Regular';
import { ArrowDCornerRightUpIcon64Regular } from './ArrowDCornerRightUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerRightUpIcon16Light,
        regular: ArrowDCornerRightUpIcon16Regular,
        solid: ArrowDCornerRightUpIcon16Solid,
    },
    20: {
        light: ArrowDCornerRightUpIcon20Light,
        regular: ArrowDCornerRightUpIcon20Regular,
        solid: ArrowDCornerRightUpIcon20Solid,
    },
    24: {
        regular: ArrowDCornerRightUpIcon24Regular,
        solid: ArrowDCornerRightUpIcon24Solid,
    },
    32: {
        regular: ArrowDCornerRightUpIcon32Regular,
    },
    64: {
        regular: ArrowDCornerRightUpIcon64Regular,
    },
};
export var ArrowDCornerRightUpIcon = forwardRef('ArrowDCornerRightUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
